import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class VonalkodAdatlapEditDto extends IdentifiableDto {
	constructor() {
		super();
		this.vizsgaVonalkod = null;
		this.vonalkod = null;
		this.adatlapPath = null;
	}

	setup(props) {
		super.setup(props);
		this.vizsgaVonalkod = props.vizsgaVonalkod;
		this.vonalkod = props.vonalkod;
		this.adatlapPath = props.adatlapPath;
		return this;
	}
}

export default VonalkodAdatlapEditDto;
